import type { KeyOfType, WithRelation, Relation } from '@/types'
import type { Entity } from '@/services/BaseService.types'

type RelationKeys = keyof Relation
type AllowedEntityKey<T> = Exclude<KeyOfType<T, Entity>, RelationKeys>

export default function withRelation<
  T extends Relation & Record<K, Entity>,
  K extends AllowedEntityKey<T>
  // @ts-expect-error imposible to type correctly
>(relation: T, key: K): WithRelation<T[K], Omit<T, K>> {
  const { [key]: entity, ...rest } = relation
  return {
    ...entity,
    position: relation.position,
    relation: rest,
  }
}
